import { render, staticRenderFns } from "./DebtorListListView.vue?vue&type=template&id=13d663f0"
import script from "./DebtorListListView.vue?vue&type=script&lang=js"
export * from "./DebtorListListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13d663f0')) {
      api.createRecord('13d663f0', component.options)
    } else {
      api.reload('13d663f0', component.options)
    }
    module.hot.accept("./DebtorListListView.vue?vue&type=template&id=13d663f0", function () {
      api.rerender('13d663f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/debtorlist/DebtorListListView.vue"
export default component.exports